"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _FeaturedTopic = _interopRequireDefault(require("@insided/destination/modules/Navigation/widget-featured-topics/FeaturedTopic"));

var _Search = _interopRequireDefault(require("../algolia/components/Search"));

var _reactSortableHoc = require("react-sortable-hoc");

var _Switcher = _interopRequireDefault(require("../control/Switcher"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var SortableList = (0, _reactSortableHoc.SortableContainer)(function (_ref) {
  var children = _ref.children;
  return (0, _preact.h)("ul", {
    className: "sortable-curated-topics-list widget-configuration_sortable-deletable-item-list__container"
  }, children);
});
var SortableItem = (0, _reactSortableHoc.SortableElement)(function (_ref2) {
  var children = _ref2.children;
  return (0, _preact.h)("li", {
    className: "sortable-curated-topic widget-configuration--sortable-list"
  }, children);
});

var convertFoundTopicToCuratedTopic = function convertFoundTopicToCuratedTopic(foundTopic) {
  return {
    id: parseInt(foundTopic.id),
    title: foundTopic.title,
    url: (0, _globals.default)('communityUrl') + foundTopic.topic_url,
    type: foundTopic.content_type === 'ideation' ? 'idea' : foundTopic.content_type
  };
};

var ContentCurationManager = function ContentCurationManager(props) {
  var _props$showTitle = props.showTitle,
      showTitle = _props$showTitle === void 0 ? false : _props$showTitle;
  return (0, _preact.h)("div", {
    className: "content-curation-manager"
  }, Boolean(props.description) && (0, _preact.h)("div", {
    className: "form-group"
  }, props.description), Boolean(props.visibilityText) && (0, _preact.h)("div", {
    className: "form-group"
  }, (0, _preact.h)("label", null, "Visibility"), (0, _preact.h)("div", {
    className: "content-curation-manager_visibility"
  }, (0, _preact.h)("div", {
    className: "clearfix content-curation-manager_visibility-switch"
  }, (0, _preact.h)(_Switcher.default, {
    on: props.enabled,
    label: props.visibilityText,
    onChange: function onChange() {
      return props.onUpdate('enabled', !props.enabled);
    }
  })), Boolean(props.showCommunityListVisibility) && (0, _preact.h)("div", {
    className: "clearfix content-curation-manager_visibility-switch"
  }, (0, _preact.h)(_Switcher.default, {
    on: props.enabledCommunityList,
    label: props.communityListVisibilityText,
    onChange: function onChange() {
      return props.onUpdate('enabledCommunityList', !props.enabledCommunityList);
    }
  })))), Boolean(showTitle) && (0, _preact.h)(_InputGroup.default, {
    title: "Title",
    qaClasses: "qa-content-curation-manager_title",
    type: "text",
    onChange: function onChange(e) {
      return props.onUpdate('title', e.target.value);
    },
    value: props.title
  }), (0, _preact.h)("div", {
    className: "form-group"
  }, (0, _preact.h)("label", null, "Topics"), (0, _preact.h)(SortableList, {
    useDragHandle: true,
    onSortEnd: function onSortEnd(result) {
      var curatedTopics = (0, _reactSortableHoc.arrayMove)(props.curatedTopics, result.oldIndex, result.newIndex);
      return props.onUpdate('curatedTopics', curatedTopics);
    }
  }, props.curatedTopics.map(function (curatedTopic, idx) {
    return (0, _preact.h)(SortableItem, {
      index: idx,
      key: curatedTopic.id
    }, (0, _preact.h)(_FeaturedTopic.default, {
      title: curatedTopic.title,
      url: curatedTopic === null || curatedTopic === void 0 ? void 0 : curatedTopic.url,
      onDelete: function onDelete() {
        var curatedTopics = props.curatedTopics.filter(function (t) {
          return t !== curatedTopic;
        });
        return props.onUpdate('curatedTopics', curatedTopics);
      },
      newStyle: true
    }));
  }), (0, _preact.h)(_Search.default, {
    isControl: true,
    searchPlaceholder: props.searchPlaceholder,
    callback: function callback(foundTopic) {
      var curatedTopics = props.curatedTopics.concat([convertFoundTopicToCuratedTopic(foundTopic)]);
      return props.onUpdate('curatedTopics', curatedTopics);
    },
    exclude: props.curatedTopics.map(function (t) {
      return "".concat(t.type, "-").concat(t.id);
    }),
    submitIconType: "add",
    withoutRedirect: true
  }))));
};

var _default = ContentCurationManager;
exports.default = _default;